   /**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('HumanResource_Resource',["$resource","$location",
        function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource(baseUrl+'rest/humanResources/:id',{}, {
            query: { method: 'GET', isArray: true },
            get:   { method: 'GET' }
        });
    }
    ]);
angular.module('FlexyBeautyApp.services').
    factory('HumanResource',["HumanResource_Resource","CategoryData","ServiceData","HumanResourceData", "HrRootOccupationRateCategory","TypeOfSale","HrRootCategory",
                            "ProductCategoryData","CureCategoryData","LoyaltyCardCategoryData","WorkingTimeRootCategory",
                            "WorkingTimeHrBookingOpenTime","WorkingTimeHrIndisponibilityTime",
        function (HumanResource_Resource,CategoryData,ServiceData,HumanResourceData,HrRootOccupationRateCategory,TypeOfSale,HrRootCategory,
                  ProductCategoryData,CureCategoryData,LoyaltyCardCategoryData,WorkingTimeRootCategory,
                  WorkingTimeHrBookingOpenTime,WorkingTimeHrIndisponibilityTime)
    {
        var  HumanResource = function (resource) {
            // Call the parent constructor
            this.id = null;
            this.isDeleted = false;
            this.label = "";
            this.firstName = "";
            this.lastName = "";
            this.phone = null;
            this.email = null;
            this.description = "";
            this.gender = "";
            this.color = "";
            this.photoId = null;
            this.hasPlanning = true;
            this.onLineBooking = true;
            this.order = null;
            this.services = [];
            this.version = null;
            if (resource!==undefined && resource!=null) {
                this.loadObject(resource);
            } else { // all services are known by default then on creation init all services
                if(CategoryData.categoryRoot) {
                    this.allServicesHaveToBeKnown(CategoryData.categoryRoot);
                }
            }
            HumanResourceData.add(this);
        }
        HumanResource.prototype.allServicesHaveToBeKnown = function (categoryRoot) {
            if(categoryRoot) {
                if(categoryRoot.services) {
                    for (let i = 0; i < categoryRoot.services.length; i++) {
                        this.services.push(categoryRoot.services[i]);
                    }
                }
                if(categoryRoot.categories) {
                    for (let i = 0; i < categoryRoot.categories.length; i++) {
                        if (categoryRoot.categories[i].services) {
                            this.allServicesHaveToBeKnown(categoryRoot.categories[i]);
                        }
                    }
                }
            }
        }

        HumanResource.prototype.loadObject = function (object) {
            if (!this.id) {
                this.id = object.id;
            }
            this.isDeleted = object.isDeleted;
            this.label = object.label;
            this.firstName = object.firstName;
            this.lastName = object.lastName;
            this.phone = object.phone;
            this.email = object.email;
            this.description = object.description;
            this.gender = object.gender;
            this.color = object.color;
            this.photoId = object.photoId;
            this.hasPlanning = object.hasPlanning;
            this.onLineBooking = object.onLineBooking;
            this.servicesId = object.servicesId;
            this.order = object.order;
            if (object.version) {
                this.version = object.version;
            }
        }
        HumanResource.prototype.loadRef = function () {
            //load ref from ids
            if (this.servicesId && CategoryData.loaded()) {
                let newServices = [];
                for (let i = 0; i < this.servicesId.length; i++) {
                    let service = ServiceData.getById(this.servicesId[i]);
                    if (service != null) {
                        newServices.push(service);
                    }
                }
                this.services = newServices;
            }
            delete this.servicesId;
        };

        HumanResource.prototype.getObjectResource = function () {
            let rsHumanResource = new HumanResource_Resource();
            rsHumanResource.id = this.id;
            rsHumanResource.isDeleted = this.isDeleted;
            rsHumanResource.label = this.label;
            rsHumanResource.firstName = this.firstName;
            rsHumanResource.lastName = this.lastName;
            rsHumanResource.phone = this.phone;
            rsHumanResource.email = this.email;
            rsHumanResource.description = this.description;
            rsHumanResource.gender = this.gender;
            rsHumanResource.color = this.color;
            rsHumanResource.photoId = this.photoId;
            rsHumanResource.hasPlanning = this.hasPlanning;
            rsHumanResource.onLineBooking = this.onLineBooking;
            rsHumanResource.order = this.order;

            rsHumanResource.servicesId = [];
            for (let i = 0; i < this.services.length; i++) {
                rsHumanResource.servicesId.push(this.services[i].getId());
            }

            return rsHumanResource;
        };

        HumanResource.prototype.copyToObject = function (object) {
            object.id = this.id
            object.label = this.label
            object.firstName = this.firstName;
            object.lastName = this.lastName;
            object.phone = this.phone;
            object.email = this.email;
            object.description = this.description;
            object.gender = this.gender;
            object.color = this.color;
            object.photoId = this.photoId;
            object.hasPlanning = this.hasPlanning;
            object.onLineBooking = this.onLineBooking;
            object.services = this.services;
        }
        HumanResource.prototype.getId = function () {
            return this.id;
        }
        HumanResource.prototype.setId = function (id) {
            this.id = id;
        }
        HumanResource.prototype.getLabel = function () {
            return this.label;
        }
        HumanResource.prototype.getId = function () {
            return this.id;
        }
        HumanResource.prototype.getName = function () {
            return this.firstName + " " + this.lastName;
        }
        HumanResource.prototype.getServices = function () {
            return this.services;
        }
        HumanResource.prototype.addService = function (service) {
            if (service && this.services.indexOf(service) == -1)
                this.services.push(service);
        }
        HumanResource.prototype.removeService = function (service) {
            let index = this.services.indexOf(service)
            if (index != -1)
                this.services.splice(index, 1);
        }
        HumanResource.prototype.hasService = function (service) {
            let know = false;
            if (this.services != null)
                know = this.services.indexOf(service) != -1;

            return know;
        }
        HumanResource.prototype.knowsCategory = function (category) {
            //Return true if HumanResource_services contains at least one item of the category.services
            if (category)
                if (category.services && category.services.length > 0) {//Sub category

                    for (let i = 0; i < category.services.length; i++) {
                        if (this.services.indexOf(category.services[i]) != -1) {
                            return true;
                        }
                    }
                } else { //master category
                    if (category.categories && category.categories.length > 0) {
                        for (let i = 0; i < category.categories.length; i++) {
                            if (this.knowsCategory(category.categories[i])) {
                                return true;
                            }
                        }
                    }
                }

            return false;
        }
        HumanResource.prototype.canPerformBookingService = function (bookingService) {
            let isFree = true;
            if (this.services.indexOf(bookingService.service) == -1) {//Resource do not have the service capability
                return false;
            }

            return isFree;
        }

        HumanResource.prototype.getSubStatCategories = function (rootCategory) {
            let subCategories = [];
            if (rootCategory === HrRootCategory) {
                subCategories = [CategoryData.categoryRoot, ProductCategoryData.categoryRoot, CureCategoryData.categoryRoot, LoyaltyCardCategoryData.categoryRoot];
            } else if (rootCategory === WorkingTimeRootCategory) {
                subCategories = [WorkingTimeHrBookingOpenTime, WorkingTimeHrIndisponibilityTime];
            }
            return subCategories;
        }

        HumanResource.prototype.statFilter = function (arrayOfDays) {
            return (this.isWorkingOnPeriod(arrayOfDays));
        }

        HumanResource.prototype.isWorkingOnPeriod = function (arrayOfDays) {
            let isWorkingOnPeriod = false;
            for (let i = 0; i < arrayOfDays.length; i++) {
                isWorkingOnPeriod = isWorkingOnPeriod || arrayOfDays[i].hrIsWorking(this.id);
                if (isWorkingOnPeriod == true) {
                    break;
                }
            }
            return isWorkingOnPeriod;
        }

        return HumanResource;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('HumanResourceSrv',["$log","HumanResource_Resource","HumanResource","HumanResourceData","CategoryData","UserActionData","ServerSrv",
        function ($log,HumanResource_Resource,HumanResource,HumanResourceData,CategoryData,UserActionData,ServerSrv)
    {
        var  hrSrv = {};

        hrSrv.query = function(successFunction,errorFunction)
        {
            HumanResource_Resource.query(
                {}, //params
                function (data) {   //success
                    HumanResourceData.clear();

                    for (var i=0;i< data.length;i++) {
                        new HumanResource(data[i]);//auto register to DATA
                    }

                    if (successFunction!== undefined)
                        successFunction(HumanResourceData.getActiveList());
                },
                function (data) {
                    $log.error(data);
                    if (errorFunction!== undefined)
                        errorFunction(data);
                });
        }
        hrSrv.reload =  function(humanResource,successFunction,errorFunction)
        {
            var humanResourceSrv = new HumanResource_Resource();
            humanResourceSrv.$get({id:humanResource.getId()}, //params : id
                function (data) {
                    humanResource.loadObject(data);
                    if (successFunction !=undefined)
                        successFunction(data);
                },
                function (data) {   //failure
                    //error handling goes here
                    //TODO
                    if (errorFunction !=undefined)
                        errorFunction(data);
                });
        }
        hrSrv.restore =  function(humanResource,successFunction,errorFunction)
        {
            HumanResourceData.restore(humanResource);
            ServerSrv.startSavingProcess(hrSrv.restoreSync, humanResource, successFunction, errorFunction);
        };
        hrSrv.restoreSync =  function(humanResource,successFunction,errorFunction)
        {
            //$timeout (function () {

            var humanResourceRes = humanResource.getObjectResource();
            humanResourceRes.$save({}, //no params
                function (data) {
                    try{
                        humanResource.setId(data.id);
                        UserActionData.add(data.userAction);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        }
        hrSrv.save =  function(humanResource,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(hrSrv.saveSync, humanResource, successFunction, errorFunction);
        };
        hrSrv.saveSync =  function(humanResource,successFunction,errorFunction)
        {
            //$timeout (function () {

            var humanResourceRes = humanResource.getObjectResource();
            humanResourceRes.$save({}, //no params
                function (data) {
                    try{
                        humanResource.setId(data.id);
                        if (!humanResource.version || (data.version && data.version > humanResource.version))
                            humanResource.version = data.version;
                        UserActionData.add(data.userAction);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        }
        hrSrv.remove =  function(humanResource,successFunction,errorFunction)
        {
            HumanResourceData.remove(humanResource);
            ServerSrv.startSavingProcess(hrSrv.removeSync, humanResource, successFunction, errorFunction);
        };
        hrSrv.removeSync =  function(humanResource,successFunction,errorFunction)
        {
            var humanResourceSrv = new HumanResource_Resource();
            humanResourceSrv.$remove({id:humanResource.getId()}, //params : id
                function (data) {
                    try{
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        }
        hrSrv.updateLocally =  function(id,objectToRestore)
        {
            var humanResource =  HumanResourceData.getById(id)
            if (humanResource!=null)
            {
                humanResource.loadObject(objectToRestore);
                humanResource.loadRef();
            }
            return humanResource;
        }
        hrSrv.removeLocally =  function(id,object)
        {
            var humanResource =  HumanResourceData.getById(id)
            if (humanResource!=null)
            {
                HumanResourceData.remove(humanResource);
            }
            console.log(humanResource)
            return humanResource;
        }
        hrSrv.addLocally =  function(id,objectToRestore)
        {
            var humanResource =  HumanResourceData.getById(id)
            if (humanResource!=null)
            {
                humanResource.loadObject(objectToRestore);
                humanResource.id = id;
                humanResource.loadRef();
                HumanResourceData.add(humanResource);
            }
            return humanResource;
        }
        hrSrv.loadRef=  function()
        {
            var humanResources = HumanResourceData.getActiveList();
            for (var i=0;i<humanResources.length;i++)
                humanResources[i].loadRef();
        }

        return hrSrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('HumanResourceData',["$log", function ($log)
    {
        var  hrDataSrv =
        {
            indexHumanResources : [], //Never deleted (used as index)
            activeHumanResources : [],//active list
            deletedHumanResources : []//deleted items
        };
        hrDataSrv.getActiveHrById =  function(humanResourceId)
        {
            for (var i=0;i<this.activeHumanResources.length;i++)
                if (this.activeHumanResources[i].id==humanResourceId)
                    return this.activeHumanResources[i];
            return null;
        }
        hrDataSrv.getById =  function(humanResourceId)
        {
            for (var i=0;i<this.indexHumanResources.length;i++)
                if (this.indexHumanResources[i].id==humanResourceId)
                    return this.indexHumanResources[i];
            return null;
        }
        hrDataSrv.getByEmail =  function(hrMail)
        {
            for (var i=0;i<this.indexHumanResources.length;i++)
                if (this.indexHumanResources[i].email==hrMail)
                    return this.indexHumanResources[i];
            return null;
        }

        hrDataSrv.getIndexOf =  function(hr)
        {
            if (hr)
                return this.indexHumanResources.indexOf(hr);
            return -1;
        }
        hrDataSrv.getByIndex =  function(hrIndex)
        {
            if (hrIndex>=0 && hrIndex<this.indexHumanResources.length)
                return this.indexHumanResources[hrIndex];
            else
                return null;
        }
        hrDataSrv.getFirstActive = function() {
            return this.activeHumanResources != null && this.activeHumanResources.length > 0 ? this.activeHumanResources[0] : null;
        }
        hrDataSrv.add =  function(humanResource)
        {
            var hrArray = this.activeHumanResources;
            if (humanResource.isDeleted)
                hrArray =  this.deletedHumanResources;
            var index = this.indexHumanResources.indexOf(humanResource);
            if (index!=-1)
            {
                var realIndex = hrArray.indexOf(humanResource);
                if (realIndex==-1)
                    hrArray.push(humanResource);
            }
            else
            {
                index = this.indexHumanResources.length;
                this.indexHumanResources.push(humanResource);
                hrArray.push(humanResource);
            }
            return index;
        }
        hrDataSrv.remove =  function(humanResource) //Soft Remove
        {
            var index =  this.activeHumanResources.indexOf(humanResource);
            if (index!=-1)
            {
                this.activeHumanResources.splice(index, 1);
                this.deletedHumanResources.push(humanResource)
                humanResource.isDeleted=true;
            }

        }
        hrDataSrv.restore =  function(humanResource) //Soft Remove
        {
            var index =  this.deletedHumanResources.indexOf(humanResource);
            if (index!=-1)
            {
                this.deletedHumanResources.splice(index, 1);
                this.activeHumanResources.push(humanResource)
                humanResource.isDeleted=false;
            }

        }
        hrDataSrv.clear =  function()
        {
            this.indexHumanResources = [];
            this.activeHumanResources = [];
            this.deletedHumanResources = [];
        }
        hrDataSrv.getActiveList =  function()
        {
            return this.activeHumanResources;
        }
        hrDataSrv.getDeletedList =  function()
        {
            return this.deletedHumanResources;
        }

        return   hrDataSrv;
    }
    ])



// WEBPACK FOOTER //
// ./js/services/models/HumanResource.js